import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isSupabaseConfigured } from "../../lib/supabaseClient";

const RegisterArea = () => {
  const navigate = useNavigate();
  const { signUp } = useAuth();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [pending, setPending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setInfo(null);
    if (!isSupabaseConfigured) {
      setError(
        "Supabase is not configured. In the Jagowelfare folder, copy .env.example to .env (or edit .env), paste your Project URL and anon public key from Supabase → Settings → API, replace the placeholder values, save, then restart npm start."
      );
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    setPending(true);
    const { error: err } = await signUp(email.trim(), password, fullName.trim(), {
      mobile: mobile.trim() || undefined,
    });
    setPending(false);
    if (err) {
      setError(err.message);
      return;
    }
    setInfo(
      "Account created. If email confirmation is enabled in Supabase, check your inbox before logging in."
    );
    setTimeout(() => navigate("/login", { replace: true }), 2500);
  };

  return (
    <section id="login_arae" className="section_padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
            <div className="section_heading">
              <h3>Register your account</h3>
              <h2>
                Become a
                <span className="color_big_heading"> member</span>
                and enhance your hand
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="author_form_area">
              {error && (
                <div className="alert alert-danger small" role="alert">
                  {error}
                </div>
              )}
              {info && (
                <div className="alert alert-success small" role="alert">
                  {info}
                </div>
              )}
              <form id="author_form" onSubmit={onSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter full name"
                    required
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter mobile number (optional)"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter password (min 6 chars)"
                    autoComplete="new-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="author_submit_form">
                  <button
                    type="submit"
                    className="btn btn_theme btn_md"
                    disabled={pending}
                  >
                    {pending ? "Please wait…" : "Register"}
                  </button>
                  <p>
                    Already have an account? <Link to="/login">Login</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterArea;
